import DeliveryContainerRoutes from "./delivery_container";
import ProductivityByProducerExpRoutes from "./productivity_by_producer_exp";
import QueryByProviderRoutes from "./query_by_provider"
import QueryByProducersRoutes from "./query_by_producers"

export default [
  ...DeliveryContainerRoutes,
  ...ProductivityByProducerExpRoutes,
  ...QueryByProviderRoutes,
  ...QueryByProducersRoutes
];
